import React, { useState } from "react";
import Image from "../Image";
import draftToHtml from "draftjs-to-html";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { Gallery } from "react-grid-gallery";
import { logger } from "../../utilities";
import { OfferingContentChild } from "../index";
import { getImmediateChildren } from "../../helpers/offeringRelations";
import Lightbox from "yet-another-react-lightbox";
import { useAppStore } from "../../data/AppStore";
import { shallow } from "zustand/shallow";

const LOG_PREFIX = "[OfferingContent.js]";
const OfferingContent = ({
  offering,
  relation,
  immediateChildren,
  buying,
  cartCallback,
}) => {
  logger.silly(LOG_PREFIX, "render");
  const [OFFERINGS, CART] = useAppStore(
    (state) => [state.OFFERINGS, state.CART],
    shallow
  );
  const [index, setIndex] = useState(-1);
  const images = (offering.images || []).map((img) => ({
    src: img,
    thumbnail: img,
    thumbnailHeight: 125,
  }));
  const handleClick = (index, item) => setIndex(index);

  const collageChildren = () => {
    logger.silly(LOG_PREFIX, ".collageChildren()", {
      offering,
      images,
      immediateChildren,
      buying,
      cartCallback,
    });

    if (
      !relation ||
      relation.type !== "child" ||
      !Array.isArray(OFFERINGS) ||
      !Array.isArray(immediateChildren)
    ) {
      return null;
    } else {
      return immediateChildren.map((r, key) => {
        let child = OFFERINGS.find((o) => o.id === r.id);
        if (!child) return null;
        const childImages = (child.images || []).map((img) => ({
          src: img,
          thumbnail: img,
          thumbnailHeight: 125,
        }));
        return (
          <OfferingContentChild
            key={key}
            className={buying ? "buyButton buying" : "buyButton"}
            offering={child}
            images={childImages}
            inCart={CART.accepted.map((i) => i.id).includes(child.id)}
            callback={(amt = 1) => {
              cartCallback(child, amt);
            }}
          />
        );
      });
    }
  };

  return (
    <div className={"OfferingContent"}>
      <div>
        {offering.sticker && (
          <div className={"OfferingSticker"}>
            <Image src={offering.sticker} fallbackSrc={null} />
          </div>
        )}

        {offering.points && (
          <div
            className={"OfferingPoints"}
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                convertToRaw(
                  EditorState.createWithContent(
                    convertFromRaw(offering.points)
                  ).getCurrentContent()
                )
              ),
            }}
          />
        )}
      </div>

      <div className={"OfferingGallery"}>
        {images.length > 0 && (
          <>
            <Gallery
              images={images}
              enableImageSelection={false}
              onClick={handleClick}
            />
            <Lightbox
              slides={images}
              open={index >= 0}
              index={index}
              close={() => setIndex(-1)}
            />
          </>
        )}
      </div>

      {Array.isArray(immediateChildren) && immediateChildren.length > 0 && (
        <div className={"OfferingVariants"}>
          {collageChildren(immediateChildren)}
        </div>
      )}
    </div>
  );
};

export default OfferingContent;
